import React, { useState, useEffect } from 'react';
import Toolbar from "../../navigation/mobile/Toolbar";
import UniversalBack from "../../common/mobile/UniversalBack";

function TurnoverRecord({turnovers}) {
    const [activeTab, setActiveTab] = useState("active");
    const [selectedTurnover, setSelectedTurnover] = useState(null);
    
    
    const isLoggedIn = !!localStorage.getItem('token');

    const openDetails = (turnover) => {
        setSelectedTurnover(turnover);
    };

    const closeDetails = () => {
        setSelectedTurnover(null);
    };

    const resolveStorageUrl = (rawPath) => {
        if (!rawPath) return null;
        if (/^https?:\/\//i.test(rawPath)) return rawPath;
        const cleaned = String(rawPath)
            .replace(/^\/?storage\//i, "")
            .replace(/^\/+/, "");
        const apiBase = process.env.REACT_APP_API_URL;
        if (!apiBase) return `/${cleaned}`;
        return `${apiBase}/storage/${cleaned}`;
    };

    const getTurnoverTitle = (turnover) => {
        if (turnover?.transaction?.action === 'bonus') {
            return turnover?.transaction?.promotion?.name || 'Bonus';
        }
        return turnover?.transaction?.payment_method?.name || 'Regular Deposit';
    };

    const getTurnoverImage = (turnover) => {
        const promo = turnover?.transaction?.promotion;
        return resolveStorageUrl(promo?.thumbnail || promo?.image);
    };


    const formatDate = (dateString) => {
        const options = { year: 'numeric', month: 'numeric', day: 'numeric' };
        return new Date(dateString).toLocaleString('en-US', options);
    };

    const activeTurnovers = turnovers.filter(turnover => turnover.status === 'active');
    const completedTurnovers = turnovers.filter(turnover => turnover.status === 'complete');

    return (
        <div className="main-router-wrapper">
            <header id="header" className="login player">
                <div className="header-left-btn-group">
                    <UniversalBack/>
                </div>
                <div className="header-title">Turnover</div>
                <div className="logo" tabIndex={0} style={{ backgroundImage: 'url("https://img.j189eb.com/jb/h5/assets/images/logo.png?v=1729676340443")' }} />
            </header>

            <div className="wrap">
                <div className="content fixed-tab player-content">
                    <div className="tab-btn-section">
                        <div className="tab-btn tab-btn-page">
                            <div className="line" style={{
                                width: 'calc(50%)',
                                transform: activeTab === "completed" ? 'translate(100%, 0px)' : 'translate(0%, 0px)'
                            }} />
                            <div className={`btn ${activeTab === "active" ? "active" : ""}`} onClick={() => setActiveTab("active")}>
                                <div className="text">Active</div>
                            </div>
                            <div className={`btn ${activeTab === "completed" ? "active" : ""}`} onClick={() => setActiveTab("completed")}>
                                <div className="text">Completed</div>
                            </div>
                        </div>
                    </div>

                    {/* Active Tab */}
                    <div className={`${activeTab === "active" ? 'd-block' : 'd-none'}`} style={{transform: activeTab === "completed" ? 'translate(-100%, 0px)' : 'translate(0%, 0px)'}}>
                        {activeTurnovers.length > 0 ? (
                            <ul className="ticket-wrap">
                                {activeTurnovers.map(turnover => {
                                    const progress = turnover.required_turnover > 0 ? (turnover.remaining_turnover / turnover.required_turnover) * 100 : 0;
                                    return (
                                        <li className="ticket completed" key={turnover.id}>
                                            <div className="ticket-inner">
                                                <div className="ticket-inner-left">
                                                <div className="title">
                                                    {turnover.transaction?.action === 'bonus'
                                                        ? turnover.transaction?.promotion?.name
                                                        : 'Regular Deposit'}
                                                    </div>


                                                    <div className="detail">
                                                        <div className="date">Event ends in : {formatDate(turnover.created_at)}</div>
                                                        <div className="detail-btn">
                                                            <a href="#" onClick={(e) => { e.preventDefault(); openDetails(turnover); }}>Details</a>
                                                        </div>
                                                    </div>
                                                    <div className="discount">
                                                    <div className="amount">
                                                            {turnover.transaction?.action === 'bonus'
                                                                ? (
                                                                    turnover.required_turnover /
                                                                    (Number(turnover.transaction?.promotion?.turnover) || 1)
                                                                ).toFixed(2)
                                                                : turnover.required_turnover}
                                                            </div>


                                                    </div>
                                                    <div className="progress-bar">
                                                        <div className="bar"><div className="bar-inner" style={{ width: `${progress}%` }} /></div>
                                                        <div className="number">
                                                            <span>৳{turnover.remaining_turnover}</span>
                                                            <span>{turnover.required_turnover}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="ticket-inner-right">
                                                    <div className="text">Active</div>
                                                </div>
                                            </div>
                                            <div className="ticket-deco open-pop">
                                                <div className="line" />
                                                <div className="line" />
                                            </div>
                                        </li>
                                    );
                                })}
                            </ul>
                        ) : (
                            <div className="no-result">
                                <div className="pic">
                                    <img alt="no-data" src="https://img.j189eb.com/jb/h5/assets/images/no-data.png?v=1729676340443&source=mcdsrc" loading="lazy" />
                                </div>
                                <div className="text">No Data</div>
                            </div>
                        )}
                    </div>

                    {/* Completed Tab */}
                    <div className={`${activeTab === "completed" ? 'd-block' : 'd-none'}`} style={{transform: activeTab === "completed" ? 'translate(0%, 0px)' : 'translate(-100%, 0px)'}}>
                        {completedTurnovers.length > 0 ? (
                            <ul className="ticket-wrap">
                                {completedTurnovers.map(turnover => (
                                    <li className="ticket completed" key={turnover.id}>
                                        <div className="ticket-inner">
                                            <div className="ticket-inner-left">
                                                <div className="title">{turnover.transaction?.promotion?.name || turnover.transaction?.payment_method?.name || 'Regular Deposit '}</div>
                                                <div className="detail">
                                                    <div className="date">Event ends in : {formatDate(turnover.created_at)}</div>
                                                    <div className="detail-btn">
                                                        <a href="#" onClick={(e) => { e.preventDefault(); openDetails(turnover); }}>Details</a>
                                                    </div>
                                                </div>
                                                <div className="discount">
                                                    <div className="amount">{turnover.required_turnover}</div>
                                                </div>
                                                <div className="progress-bar">
                                                    <div className="bar"><div className="bar-inner" style={{ width: '100%' }} /></div>
                                                    <div className="number"><span>৳{turnover.required_turnover}</span><span>100%</span></div>
                                                </div>
                                            </div>
                                            <div className="ticket-inner-right">
                                                <div className="text">
                                                    <span className="item-icon" style={{ backgroundImage: 'url("https://img.j189eb.com/jb/h5/assets/images/icon-set/icon-check-type01.svg")' }} /> Completed
                                                </div>
                                            </div>
                                        </div>
                                        <div className="ticket-deco open-pop">
                                            <div className="line" />
                                            <div className="line" />
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        ) : (
                            <div className="no-result">
                                <div className="pic">
                                    <img alt="no-data" src="https://img.j189eb.com/jb/h5/assets/images/no-data.png?v=1729676340443&source=mcdsrc" loading="lazy" />
                                </div>
                                <div className="text">No Data</div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            {selectedTurnover && (
                <>
                    <div className="pop-transaction-records-details active">
                        <div className="bank-name">
                            {getTurnoverImage(selectedTurnover) && (
                                <img
                                    alt="Promotion"
                                    src={getTurnoverImage(selectedTurnover)}
                                    loading="lazy"
                                    onError={(e) => {
                                        e.currentTarget.style.display = 'none';
                                    }}
                                />
                            )}
                            <span>{getTurnoverTitle(selectedTurnover)}</span>
                        </div>

                        <a
                            onClick={closeDetails}
                            className="btn-closed"
                            style={{ maskImage: 'url("https://img.j189eb.com/jb/h5/assets/images/icon-set/icon-cross-type01.svg?v=1730201806250")' }}
                        />

                        <div className="header">Turnover Details</div>
                        <div className="content pop-content processing">
                            <div className="tab-content tab-content-page">
                                <div className="inner-wrap">
                                    <div className="inner-box" style={{ display: 'block' }}>
                                        <div className="transaction-details-wrap">
                                            {(() => {
                                                const required = Number(selectedTurnover.required_turnover) || 0;
                                                const completed = Number(selectedTurnover.remaining_turnover) || 0;
                                                const completePercent = required > 0 ? Math.min((completed / required) * 100, 100) : 0;

                                                return (
                                                    <>
                                                        <div className="title">
                                                            <h3>Turnover Details</h3>
                                                            <div className="tags">{selectedTurnover.status || '-'}</div>
                                                        </div>
                                                        <div className="details-box">
                                                <div className="info">
                                                    <div className="name">Turnover ID</div>
                                                    <div className="value">{selectedTurnover.id ?? '-'}</div>
                                                </div>
                                                <div className="info">
                                                    <div className="name">Type</div>
                                                    <div className="value">{selectedTurnover.transaction?.action || 'deposit'}</div>
                                                </div>
                                                <div className="info">
                                                    <div className="name">Promotion</div>
                                                    <div className="value">{selectedTurnover.transaction?.promotion?.name || '-'}</div>
                                                </div>
                                                <div className="info">
                                                    <div className="name">Required Turnover</div>
                                                    <div className="value">৳{selectedTurnover.required_turnover ?? 0}</div>
                                                </div>
                                                <div className="info">
                                                    <div className="name">Complete Turnover</div>
                                                    <div className="value">৳{selectedTurnover.remaining_turnover ?? 0}</div>
                                                </div>
                                                <div className="info">
                                                    <div className="name">Complete %</div>
                                                    <div className="value">{completePercent.toFixed(0)}%</div>
                                                </div>
                                                <div className="info">
                                                    <div className="name">Created</div>
                                                    <div className="value">{selectedTurnover.created_at ? formatDate(selectedTurnover.created_at) : '-'}</div>
                                                </div>
                                                <div className="info">
                                                    <div className="name">Updated</div>
                                                    <div className="value">{selectedTurnover.updated_at ? formatDate(selectedTurnover.updated_at) : '-'}</div>
                                                </div>
                                                <div className="info">
                                                    <div className="name">Transaction ID</div>
                                                    <div className="value">{selectedTurnover.transaction?.transaction_id || selectedTurnover.transaction_id || '-'}</div>
                                                </div>
                                                <div className="info">
                                                    <div className="name">Deposit Method</div>
                                                    <div className="value">{selectedTurnover.transaction?.payment_method?.name || '-'}</div>
                                                </div>
                                                        </div>
                                                    </>
                                                );
                                            })()}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="pop-bg d-block" onClick={closeDetails} />
                </>
            )}
            <Toolbar/>
        </div>
    );
}

export default TurnoverRecord;
